import ArticlesExchanged from "@/components/articles-lists/articles-exchanged";
import ArticlesNotReturned from "@/components/articles-reject-lists/articles-not-returned";
import ArticlesNotTreatedByLogistician from "@/components/articles-reject-lists/articles-not-treated-by-logistician";
import ArticlesRejectedByLogistician from "@/components/articles-reject-lists/articles-rejected-by-logistician";
import ArticlesToHandleByMerchant from "@/components/articles-reject-lists/articles-to-handle-by-merchant";
import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Accordion } from "@babackapp/ui/components/accordion";
import { Button } from "@babackapp/ui/components/button";
import { useState } from "react";
import { useCurrentReturnRequest } from "../utils/current-return-request-context";
import { useRejectLineItems } from "./hooks/use-reject-line-items-context";
import ArticlesValidatedByLogistician from "@/components/articles-reject-lists/articles-validated-by-logistician.tsx";

export function RejectForm({
  onSubmit,
}: {
  onSubmit: (
    lineItem: ReturnRequestLineItemDto[],
    returnRequestId: string,
    data: object,
  ) => void;
  handleClose: () => void;
}) {
  const t = useTranslation();
  const currentReturnRequest = useCurrentReturnRequest();
  const { items: lineItems } = useRejectLineItems();
  const [itemInModificationState] = useState(0);

  return (
    <div className="no-scrollbar overflow-auto">
      <div className="space-y-8 flex-1">
        <div className="space-y-4">
          <Accordion type="multiple" defaultValue={["toHandleByMerchant"]}>
            <ArticlesToHandleByMerchant />
            <ArticlesValidatedByLogistician />
            <ArticlesRejectedByLogistician />
            <ArticlesNotTreatedByLogistician />
            <ArticlesNotReturned />
            <ArticlesExchanged />
          </Accordion>
        </div>
      </div>

      <div className="flex items-center justify-center gap-4 sticky bottom-0 py-8 mt-10 bg-gradient-to-b from-white/0 to-white">
        <Button
          variant="default"
          disabled={itemInModificationState > 0}
          onClick={() => onSubmit(lineItems, currentReturnRequest.id, {})}
        >
          {t("misc.validate")}
        </Button>
      </div>
    </div>
  );
}
